/**
 * Normalize a Sources & Uses difference to the precision displayed in reports.
 * Differences smaller than half a cent are floating-point noise at currency
 * precision and should be reported as balanced.
 */
export function normalizeSourcesUsesBalance(value) {
  const difference = Number(value);
  if (!Number.isFinite(difference) || Math.abs(difference) < 0.005) return 0;
  return difference;
}
